import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const ResendVertificationEmail = async (locale) => {
    return Axios({
        method: 'POST',
         headers,
        data: { locale },
        url: `${endpointURL}/api/profile/resend-vertification-email`
    })
}

const EditAccountInfor = async (firstName, lastName) => {
    return Axios({
        method: 'POST',
         headers,
        data: { firstName, lastName },
        url: `${endpointURL}/api/profile/edit-account-infor`
    })
}

const UploadAvatar = async function (file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);

    return Axios({
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization':`Bearer ${localStorage.getItem('token')}` },
        data: formData,
        url: `${endpointURL}/api/profile/upload-avatar`,
        onUploadProgress
    })
}
const GetAvatar = async function () {
    return Axios({
        method: 'GET',
         headers,
        url: `${endpointURL}/api/profile/get-avatar`
    })
}
const ChangePassword = async function (password, newpassword, confirmpassword) {
    return Axios({
        method: 'POST',
         headers,
        data: { password, newpassword, confirmpassword },
        url: `${endpointURL}/api/profile/change-password`
    })
}

export {
    ResendVertificationEmail,
    EditAccountInfor,
    UploadAvatar,
    GetAvatar,
    ChangePassword,
};
